import { Box, Flex } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import ClientList from './ClientList';

function Clients() {
  return (
    <Flex height="100%" gap="20px">
      <ClientList w="30%" />
      <Box flex={1}>
        <Outlet />
      </Box>
    </Flex>
  );
}

export default Clients;
